import { z } from "zod";

export enum JoinStatus {
  WaitApproval = "wait_approval",
  WaitJoin = "wait_join",
  Joined = "joined",
  Blocked = "blocked",
}

export const JoinStatusZod = z.enum(["wait_approval", "wait_join", "joined", "blocked"]);
